'use client'

import { useEffect, useRef, useState } from "react"
import styles from './ua.module.scss'
import Button from "../button/Button"
import Dropdown from "../dropdown/Dropdown"
import Form from "../form/Form"
import Icon from "../icon/Icon"
import StackedPanel from "../panel/StackedPanel"
import PanelBody from "../panel/PanelBody"
import PanelFooter from "../panel/PanelFooter"

export default function PreOwnedButton(props) {
  
  const [years,setYears] = useState(props.facets.year.sort((a,b) => parseInt(b.key) - parseInt(a.key)))
  const [applied,setApplied] = useState(false)
  const [selected,setSelected] = useState(props.filters?.year || [])
  const [certified,setCertified] = useState(props.filters.condition?.includes("certified"))
  
  const ddPreOwned = useRef()
  
  useEffect(() => {
    setApplied(false)
    if (props.filters.year) {
      if (Array.isArray(props.filters.year)) {
        setSelected(props.filters.year.map(y => parseInt(y)))
        if (props.filters.year.length > 0) setApplied(true)
      } else {
        setSelected(props.filters.year.split(",").map(y => parseInt(y)))
        if (props.filters.year.split(",").length > 0) setApplied(true)
      }
    }
    if (props.filters.condition && props.filters.condition.length > 0 && props.filters.condition.includes('pre-owned')) {
      setCertified(false)
      setApplied(true)
    }
    if (props.filters.condition && props.filters.condition.length > 0 && props.filters.condition.includes('certified')) {
      setCertified(true)
      setApplied(true)
    }
  }, [props.filters])
  
  useEffect(() => {
    if (certified) {
      setYears(props.facets.year_certified.sort((a,b) => parseInt(b.key) - parseInt(a.key)))
    } else {
      setYears(props.facets.year.sort((a,b) => parseInt(b.key) - parseInt(a.key)))
    }
  }, [certified])

  useEffect(() => {
    if (certified) {
      setYears(props.facets.year_certified.sort((a,b) => parseInt(b.key) - parseInt(a.key)))
    } else {
      setYears(props.facets.year.sort((a,b) => parseInt(b.key) - parseInt(a.key)))
    }
  }, [props.facets.year])
  
  const toggle = (e) => {
    if (e) e.preventDefault()
    ddPreOwned.current.toggle()
  }
  
  const isSelected = (brand) => {
    return selected.indexOf(brand) >= 0
  }
  
  const onItemToggle = (e, item) => {
    const yearList = years.map(e => e.key)
    const list = [...selected.filter(e => yearList.includes(e) )]
    if (list.indexOf(item.key) >= 0) {
      list.splice(list.indexOf(item.key), 1)
    } else {
      list.push(item.key)
    }
    setSelected(list)
  }
  
  const clear = (e) => {
    setSelected([])
    setCertified(false)
    props.listingRef.current.applyFilters({ year: [], condition: [], clear: true })
    toggle(e)
  }
  
  const onSubmit = (e) => {
    let conditions = []
    if (certified) {
      conditions = ['certified']
    } else {
      conditions = ['pre-owned']
    }
    props.listingRef.current.applyFilters({ year: selected, condition: conditions })
    setApplied(true)
    toggle(e)
  }
  
  return <>
    <Button theme={["filter", (applied ? 'filter-on' : '')]} onClick={e => toggle(e) } label={"Filter by Condition & Year"}>
      <span>{ 'Pre-owned' }</span>
    </Button>
    <Dropdown {...props} key="brands" ref={ddPreOwned} position={'left'} body={'padded'} offset={'12px'} title="Condition & Year">
      <Form id="brand_picker" name="Brand Picker" onSubmit={e => onSubmit(e)}>
        <StackedPanel>
          <PanelBody padded={true}>
            <div className="flex-column flex-with-gap">
              <div className="flex-col">
                <div className={styles.br}>
                  <div className={ styles.bri }>
                    <Button theme={["gray-light-hover", !certified ? "filter-on" : "transparent", "filter-opt", "inline"]} label={ 'All Pre-owned' } onClick={e => setCertified(false)}></Button>
                  </div>
                  <div className={ styles.bri }>
                    <Button theme={["gray-light-hover", certified ? "filter-on" : "transparent", "filter-opt", "inline"]} label={ 'Certified Only' } onClick={e => { setCertified(true);}}></Button>
                  </div>
                </div>
              </div>
              <div className="flex-col">
                <div className={styles.br}>
                  <div className={ styles.bri }>
                    <Button theme={["gray-light-hover", selected.length == 0 ? "filter-on" : "transparent", "filter-opt", "inline"]} label={ 'Any Year' } onClick={() => setSelected([])}></Button>
                  </div>
                  { years.map(b => (
                    <div key={b.key} className={ styles.bri }>
                      <Button theme={["gray-light-hover", isSelected(b.key) ? "filter-on" : "transparent", "filter-opt", "inline"]} label={ b.key + ' (' + b.doc_count + ')' } onClick={e => onItemToggle(e, b)}></Button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </PanelBody>
          <PanelFooter>
            <div className="flex-row flex-with-gap flex-full">
              <div className="flex-col flex-stretch flex-col50">
                <Button theme={'secondary'} label="Apply Filters"></Button>
              </div>
              <div className="flex-col flex-stretch flex-col50">
                <Button theme={'gray-light'} disabled={!applied} label="Clear" onClick={e => clear()}></Button>
              </div>
            </div>
          </PanelFooter>
        </StackedPanel>
      </Form>
    </Dropdown>
  </>
  
}